module.exports = __webpack_public_path__ + "img/6.da4600d1.jpeg";